<template>
  <n-full-screen overlay v-if="!initialized && loading">
    <n-spinner class="span-6 flex-center" />
  </n-full-screen>

  <n-scrollable v-else>
    <n-layout>
      <n-column :span="6" class="title">
        <n-text-model color="accent" size="xl" weight="regular">
          {{ $t('bookRide.title') }}
        </n-text-model>
      </n-column>

      <n-text class="span-6" preset="body">
        {{ $t('bookRide.codeDescription') }}
      </n-text>

      <n-input
        v-model="code"
        class="code-input"
        type="text"
        :placeholder="$t('bookRide.codePlaceholder')"
        @keyup.enter="() => findRideByCode(code)"
      />

      <n-button
        @click="() => findRideByCode(code)"
        :loading="loading"
        size="lg"
        block
      >
        {{ $t('bookRide.codeButton') }}
      </n-button>
    </n-layout>

    <n-seperator />

    <download-app />

    <n-layout :spacing-y="false" :spacing-bottom="false" :top-gap="1">
      <n-text class="span-6 explanation-description" preset="sub">
        {{ $t('bookRide.explanationDescription') }}
      </n-text>

      <n-button
        size="md"
        block
        type="outlined"
        inverted
        :href="$t('bookRide.explanationLink')"
        target="_blank"
      >
        {{ $t('bookRide.explanationButton') }}
      </n-button>
    </n-layout>
  </n-scrollable>
</template>

<script>
import { mapActions } from 'vuex';
import DownloadApp from './downloadApp';

export default {
  name: 'landingBookRideStart',
  components: {
    DownloadApp,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.params.code) {
        vm.findRideByCode(to.params.code);
      } else {
        vm.initialized = true;
      }
    });
  },
  data() {
    return {
      code: '',
      loading: false,
      initialized: false,
    };
  },
  methods: {
    ...mapActions('trip', ['searchCode']),
    findRideByCode(code) {
      if (!code || this.loading) {
        return;
      }

      this.loading = true;

      this.searchCode(code)
        .then(() => {
          this.$router.push({ name: 'landing-book-ride.details' });
        })
        .catch((e) => {
          const { identifier } = e.response?.data ?? {};
          const translationKey = `bookRideDetails.bookingErrors.${identifier}`;

          this.$error(
            this.$te(translationKey)
              ? this.$t(translationKey)
              : this.$t('bookRide.codeError')
          );
        })
        .finally(() => {
          this.loading = false;
          this.initialized = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.code-input {
  margin: 1.25rem 0 0.5rem 0;
}

.explanation-description {
  margin-bottom: 1rem;
}
</style>
